'use client';

import React, { FC } from 'react';
import classNames from 'classnames';
import Head from 'next/head';

import { TypeProduct } from '@/core/generated-types';
import styles from './YotpoReviewStars.module.scss';
import { getShopifyProductId } from '@/utils/getShopifyProductId';
import scrollTo from '@/utils/scrollTo';
import useFeature from '@/hooks/useFeature';

export interface YotpoReviewStarsProps {
  product?: TypeProduct;
  productID?: string;
}

const YotpoReviewStars: FC<YotpoReviewStarsProps> = ({
  product,
  productID,
}) => {
  const appKey = process.env.NEXT_PUBLIC_YOTPO_APP_KEY;
  const shouldUsePlayKitId = useFeature('sub-squad-pk-yotpo-override');

  const shopifyProductId = product
    ? getShopifyProductId(product, shouldUsePlayKitId)
    : productID;

  const scrollToReviewsWidget = () => {
    // Matches YotpoReviewsWidget component
    const id = '[data-yotpo-product-id]';
    const reviewsWidget = document.querySelector(id);
    if (reviewsWidget) {
      scrollTo({
        id,
        offSet: -180,
      });
    }
  };

  return appKey && shopifyProductId ? (
    <>
      {/* Preconnect to Yotpo CDN to speed up script loading */}
      <Head>
        <link rel="preconnect" href="https://staticw2.yotpo.com" />
      </Head>
      <div
        className={classNames('yotpo bottomLine yotpo-small', styles.root)}
        data-appkey={process.env.NEXT_PUBLIC_YOTPO_APP_KEY}
        data-product-id={shopifyProductId}
        data-product-models={shopifyProductId}
        data-testid="yotpo-review-stars"
        onClick={scrollToReviewsWidget}
      />
    </>
  ) : null;
};

export default React.memo(YotpoReviewStars);
